import { IClickElement } from '../models/base-element';
import { PortalActionEvent } from '../models/portal-action-event';

export class ActionElementComponent {
  action($event: Event, element: IClickElement, options?: any, type: 'SUBMIT' | 'CHANGE' = 'SUBMIT') {
    $event.stopPropagation();
    $event.preventDefault();

    let target = $event.target;
    if (target) {
      this.fireActionEvent(target, element, options, type);
    }
  }

  fireActionEvent(target: any, element: IClickElement, options?: any, type: 'SUBMIT' | 'CHANGE' = 'SUBMIT') {
    target?.dispatchEvent(
      new CustomEvent(PortalActionEvent.EVENT_NAME, {
        detail: { element: element, options: options, type: type } as PortalActionEvent,
        bubbles: true,
      })
    );
  }
}
